import { productDescriptionStyles as styles } from "@insite/content-library/Components/ProductDescription";
import { commonLinkStyles, customLinkHoverStyles, headingCommon } from "@solveindustrial/Utilities/styleguide";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.productDetailLink = {
    ...styles.productDetailLink,
    typographyProps: {
        ...styles.productDetailLink?.typographyProps,
        ...headingCommon,
        css: css`
            ${commonLinkStyles}
            ${customLinkHoverStyles}
            font-weight: 700;
            line-height: 22px;

            ${mediaQueriesBP.minMD} {
                line-height: 22px;
            }
        `,
        mergeCss: true,
    },
};

styles.productDetailDescription = {
    ...styles.productDetailDescription,
    ...headingCommon,
    css: css`
        ${commonLinkStyles}
        ${customLinkHoverStyles}
        font-weight: 700;
        line-height: 22px;
        ${mediaQueriesBP.minMD} {
            line-height: 22px;
        }
    `,
};
